import styled from "@emotion/styled";

export const IconListItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 9rem;
  justify-content: flex-start;
  padding: 0.5rem;
  border: 0.4px solid transparent;

  &:hover {
    border-radius: 25px;
    box-shadow: 2px 2px 2px rgb(192, 198, 208);
    border: 0.4px solid rgb(192, 198, 208);
    cursor: pointer;
  }

  span {
    color: gray;
  }
`;

export const IconName = styled.span`
  width: 8rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 1rem;

  color: ${({ theme }) => theme.colors.secondaryColor} !important;
`;
